export const Image = ({ title, largeImage, smallImage, desc, date }) => {
  return (
    <div className="portfolio-item">
      <div className="hover-bg">
        <a href={largeImage} title={title} data-lightbox-gallery="gallery1">
          <div className="hover-text">
            <h4 style={{ marginTop: -90 }}>{title}</h4>
            <p>{date}</p>
            <p>{desc}</p>
          </div>
          <img src={smallImage} className="img-responsive" alt={title} />
        </a>
      </div>
    </div>
  );
};
